<template>
    <div>
        <PlanRenew v-if="roleName=='Student'"/>
        <VersionMsg/>
     
        <v-footer padless light :color="getFooterColor">
            <v-col class="text-right font-weight-regular">
                <!-- {{footerText}} -->
                 &copy; {{new Date().getFullYear()}} Copyright EDG
            </v-col>
        </v-footer>
    </div>
</template>

<script>
import VersionMsg from './VersionMsg.vue'
import PlanRenew from './PlanRenew.vue'

export default {
    name:'Footer',
    components:{
        VersionMsg,
        PlanRenew,
        
    },
    computed:{
        getFooterColor:function(){
            return this.$store.getters['settings/footerColor']
        },
        footerText:function(){
            return this.$store.getters['settings/footerText']
        },
        roleName(){
            return this.$store.getters['dashboard/userInfo'].roleName
        }
    }
}
</script>